import { render, staticRenderFns } from "./ContactsMenu.vue?vue&type=template&id=4c0f4bc8&scoped=true"
import script from "./ContactsMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactsMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContactsMenu.vue?vue&type=style&index=0&id=4c0f4bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f4bc8",
  null
  
)

export default component.exports